import React from 'react';
import { useParams } from 'react-router-dom';
import { useUpdateComponentState } from '../../../hooks';
import MisconceptionCards, {
  SSO_CARD_ICONS,
} from '../../components/MisconceptionCards';
import AIAttackScam from '../../components/AIAttackScam';
import AiFace from '../../../../../../assets/sme/sso/AiFace.gif';
import SenderVerification from '../../components/SenderVerification';
import FourPartIllustration from '../../../../../../assets/sme/sso/FourPartIllustration.png';
interface ISection1Props {
  settings: any;
}

const Section1: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const ID = '2';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = React.useMemo(
    () => settings?.paragraphs[1],
    [settings?.paragraphs]
  );

  const updateComponentState = useUpdateComponentState();
  const handleMisconceptionCardsComplete = React.useCallback(() => {
    updateComponentState(
      p_course,
      p_topic,
      ID,
      'student-training-sso-section1-1'
    );
  }, [updateComponentState, p_course, p_topic, ID]);

  const handleSenderVerificationComplete = React.useCallback(() => {
    updateComponentState(
      p_course,
      p_topic,
      ID,
      'student-training-sso-section1-2'
    );
  }, [updateComponentState, p_course, p_topic, ID]);

  return (
    <div className="topic-section-1">
      <MisconceptionCards
        title={paragraphsSettings?.title}
        items={paragraphsSettings?.risks}
        tips={paragraphsSettings?.risksTips}
        subTitle={paragraphsSettings?.subTitle}
        icons={SSO_CARD_ICONS}
        id="student-training-sso-section1-1"
        onComplete={handleMisconceptionCardsComplete}
      />
      <AIAttackScam
        title={paragraphsSettings?.aiAttackScamData.title}
        image={AiFace}
        description={paragraphsSettings?.aiAttackScamData.description}
      />
      <SenderVerification
        title={paragraphsSettings?.senderVerificationData?.title}
        steps={paragraphsSettings?.senderVerificationData?.steps}
        id="student-training-sso-section1-2"
        onComplete={handleSenderVerificationComplete}
        imgBg={FourPartIllustration}
      />
    </div>
  );
};

export default Section1;
